import { render, staticRenderFns } from "./HistoricoChecadas.vue?vue&type=template&id=e0220c54&scoped=true"
import script from "./HistoricoChecadas.vue?vue&type=script&lang=js"
export * from "./HistoricoChecadas.vue?vue&type=script&lang=js"
import style0 from "./HistoricoChecadas.vue?vue&type=style&index=0&id=e0220c54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0220c54",
  null
  
)

export default component.exports